//icons
import Icon from '../../icons/Icon';


//interfaces
import { IconLibrary } from '../../../../interfaces/icon/IconLibrary';
import { ICountrySelectDropdown } from '../../../../interfaces/textInputs/phoneNumberInputs';

import useCountrySelectDropdown from './CountrySelectDropdown.hooks';



const CountrySelectDropdown = ({id, setValue, buttonLabel, options, defaultValue, canDeselect, buttonAriaLabel}: ICountrySelectDropdown) => {
    
    const {
        dropdownRef,
        setShowDropdown,
        showDropdown,
        activeElement,
        handleKeyPressOnButton,
        selectedElement,
        setActiveElement, 
        setSelectedElement,
        handleKeyPressInList
    } = useCountrySelectDropdown({defaultValue, options, setValue, id, canDeselect});
    
    return (
        <div className='country-select-drop-down-button-container' ref={dropdownRef}>
            <button 
                id={`${id}-open-menu-button`}
                name={`${buttonLabel} select`}
                aria-label={buttonAriaLabel}
                className='country-select-dd-button'
                onClick={() => {setShowDropdown(!showDropdown)}}
                role='combobox'
                aria-controls={id}
                aria-owns={id}
                aria-expanded={showDropdown}
                aria-activedescendant={activeElement}
                onKeyDown={(e) => handleKeyPressOnButton(e)}
                type={'button'}
            >
                <span className='country-select-button-label'>{buttonLabel}</span>
                <Icon iconName={IconLibrary.CHEVRON_RIGHT} sizeInPx='7' color='var(--thriveOffBlack)' className='chevron-down'/>
            </button>
            
            {showDropdown && 
                <div className='country-select-drop-down-container' id={id} role='listbox'>

                    {options.map((el, idx) => {
                        return (
                            <div 
                                tabIndex={-1}
                                className={`country-select-dd-option ${selectedElement === el.value ? 'selected' : activeElement ===  `${id}-option-${idx}` ? 'active' : ''}`}
                                key={`${id}-option-${idx}`}
                                id={`${id}-option-${idx}`}
                                role='option'  
                                onMouseOver={()=>{setActiveElement(`${id}-option-${idx}`)}}
                                onClick={() => {
                                    setSelectedElement((canDeselect && el.value === selectedElement) ? '' : `${el.value}`);
                                    setShowDropdown(false);}}
                                onKeyDown={(e) => handleKeyPressInList(e)}
                                onFocus={() => setActiveElement(`${id}-option-${idx}`)}
                                >
                                    {el.label}
                            </div>
                        )
                    })}

                </div>
            }
        </div>
    )
}

export default CountrySelectDropdown;